export const BASE_ROLES = [
  'superadmin',
  'general',
  'beauty_advisor',
  'merchandiser',
  'promotor',
];

export const COMPLETION_ROLES = [
  'regional_manager',
  'regional_support',
  'key_account_manager',
  'group_key_account_manager',
  'superadmin',
  'general',
  'beauty_advisor',
  'merchandiser',
  'promotor',
];

export const SHIPPING_DATE_ROLES = ['spv_logistic', 'superadmin', 'general'];

export const BA_MERCHANDISER_ROLES = [
  'beauty_advisor',
  'merchandiser',
  'promotor',
];

export const EDIT_ACCESS_ROLES = [
  'superadmin',
  'general',
  'general_manager_marketing',
];
